export default "__VITE_ASSET__3jOkgXmu__"